import client from '@/api/client'
import filterPageItemsQuery from '@/api/gql/filter-page/query/filter-page-items.gql'
import { formatVariants } from '../FilterPage/transformation-helpers'

function fetchFilterPageItemsData(ids) {
  return client
    .query({
      query: filterPageItemsQuery,
      variables: { ids },
    })
    .then(({ data: { filterPageItems } }) => {
      filterPageItems.forEach(function(item) {
        formatVariants(item)
      })
      return filterPageItems
    })
}

export default fetchFilterPageItemsData
